import React, { useMemo } from "react";
import { useDrag } from "react-dnd";
import { ItemTypes } from "../flows/DialogNode";
import { IoClose } from "react-icons/io5";
import { FileIcon } from "./FileIcon";
import { IoTrashOutline } from "react-icons/io5";
import { devModeConfig } from "../../components/DevMode.helpers";
export const NodeRendererFile = ({
  element,
  getNodeProps,
  level,
  handleSelect,
  onRemove,
  onClose,
  changedIds,
  isSelected
}) => {

  const handleClose = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClose && onClose(element);
  };

  const handleRemove = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onRemove && onRemove(element);
  };

  const isOpenFile = element.id.endsWith("/open");
 
  const [{isDragging}, drag] = useDrag(() => ({
    type: `${ItemTypes.FILE_ITEM}_${element.metadata?.type}` ,
    item: element,
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  }), [element])
  

  const fontColor = useMemo(()=>{
    if (element.metadata?.isNewFile){
      return "yellow";
    }
    if(element.metadata?.type && devModeConfig[element.metadata?.type].fontColor){
      return devModeConfig[element.metadata?.type].fontColor;
    }
    return "inherit";
  }, [element.metadata?.isNewFile, element.metadata?.type]);

  return  (
    <div {...getNodeProps()} ref={drag} style={{ paddingLeft: 10 * (level - 1), textWrap: "nowrap", scale: isDragging ? 1.5 : 1, display: "flex", alignItems: "center"  }}>
      <>
        {isOpenFile &&
          <IoClose onClick={handleClose} style={{minWidth: 18, marginLeft: 4, width: 18, height: 18, cursor: "pointer"}} />
        }
        <FileIcon type={element.metadata?.type} method={element.metadata?.item?.metodo} templateType={element.metadata?.item?.tipoTemplate} style={{minWidth: 18, width: 18, verticalAlign: "middle", marginRight: 5}} />
      </>
      <span style={{color: fontColor, flex: 1}}>
        {element.name}
        {isOpenFile && changedIds.includes(element.id.replace("/open", "")) && "*"}
      </span> 
      {isSelected && !isOpenFile &&
        <IoTrashOutline onClick={handleRemove} style={{marginLeft: 4, width: 18, minWidth: 18, height: 18, cursor: "pointer"}} color="#a80303" />
      }
    </div>
  )  
}
